// extracted by mini-css-extract-plugin
export default {"loading-container":"Loader_loading-container__p0+5p","loader":"Loader_loader__Iv4Mh"};